import { lazy } from 'react';
import reactGA from "react-ga4";


// const reactGA = lazy(() => import('../components/socialMedia/ReactGA'));

export async function setAnalyticsEvent(pageName, event) {
  try {
    reactGA.initialize(process.env.REACT_APP_GA_KEY);
    reactGA.send({
      hitType: "pageview",
      page: pageName,
      title: "Bidd GA"
    });
    reactGA.event({
      category: "User",
      action: `${event}`,
      label: `${event}`,
    });
    console.log('Successfully Triggered GA Event: ', event);
  } catch (error) {
    console.error("Error in setAnalyticsEvent:", error);
  }
}

export async function setCleverTapEvent(eventName, event, state) {
  try {
    if (window.clevertap.profile.length === 0) {
      window.clevertap.profile.push({
        "Site": {
          "Email": state
        }
      });
    }
    window.clevertap.event.push(eventName);
  } catch (error) {
    console.error("Error in setCleverTapEvent:", error);
  }
}
